export default __webpack_public_path__ + "static/media/hero-bg-03.7bacd37f.jpg";